import { writable } from 'svelte/store';

export const charts = writable([]);
export const gettingCharts = writable([]);
export const units = writable([]);
export const roles = writable([]);
export const people = writable([]);
export const groups = writable([]);
export const selectedPeople = writable([]);